import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap'
import { Link } from "@StarberryUtils";
import Lightbox from 'react-image-lightbox';
import { isEmpty } from "lodash";
import 'react-image-lightbox/style.css';

const FloorPlanModal = (props) => {
    const [show, setShow] = useState(false);

    
    var lightImages2 = []
    
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    }

    let fullimgpath = ''
    fullimgpath = props?.floorplanimg
    //console.log("algolia",fullimgpath)
    if (!isEmpty(props?.processedImagesFloorplan) && typeof fullimgpath !== "undefined") {
        let srcImgUrl = fullimgpath.split("amazonaws.com/");
        srcImgUrl = srcImgUrl[1]
        srcImgUrl = srcImgUrl?.replace("x.prod","i.prod")
        srcImgUrl = srcImgUrl?.replace("x.dev","i.dev")

        let parseresizedata = JSON.parse(props.processedImagesFloorplan)
        let imgformat = 'webp'
        let imgsize = '1600x'

        if (!isEmpty(parseresizedata[srcImgUrl])) {
            if (!isEmpty(parseresizedata[srcImgUrl][imgformat])) {
                if (!isEmpty(parseresizedata[srcImgUrl][imgformat][imgsize])) {
                    fullimgpath = parseresizedata[srcImgUrl][imgformat][imgsize]
                }
            }
        }
    } else {
        if(typeof fullimgpath !== "undefined") {
            fullimgpath = fullimgpath.replace("i.prod","x.prod")
            fullimgpath = fullimgpath.replace("i.dev","x.dev")
            fullimgpath = fullimgpath.replace("jpg","webp")
            if (!fullimgpath.match(/1600x/g))
                fullimgpath = fullimgpath.replace("floorplan/", "floorplan/1600x/");
            //console.log("modified",fullimgpath)
        }
    }

    if(props?.floorplanimg){
        lightImages2.push(props?.floorplanimg)
    }
    else {
        lightImages2.push(fullimgpath)
    }
    return (
        <>
            <a href="javascript:void(0)" className="map-expand-link" onClick={(e) => openLighboxMobile(e,0)}><i className="icon-map-view"></i> <span className="exp-txt text-uppercase d-md-block d-none">View Floorplan</span></a>

            {isOpen && lightImages2.length != 0 && (
                <Lightbox
                    wrapperClassName="light-box-image-zoom"
                    mainSrc={lightImages2[photoIndex]}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                    setPhotoIndex((photoIndex + lightImages2.length - 1) % lightImages2.length)
                    }
                    onMoveNextRequest={() =>
                    setPhotoIndex((photoIndex + 1) % lightImages2.length)
                    }
                />
            )}
        </>
    );
}

export default FloorPlanModal;
